<div class="fx-layout-column">
  <h2> Update Security Questions </h2>
  @if (questionsForm) {
    <form [formGroup]="questionsForm">
      <div class="fx-layout-row fx-layout-xs-column">
        <div class="fx-flex-35">
          <mat-form-field>
            <mat-label>Security Question 1</mat-label>
            <mat-select formControlName="firstQuestion">
              @for (question of getAvailableQuestions('firstQuestion'); track question) {
                <mat-option [value]="question.id">
                {{question.questionText}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="fx-flex-20 flex-offset-40px">
          <mat-form-field>
            <mat-label>Enter an answer</mat-label>
            <input matInput formControlName="firstQuestionAnswer">
            @if (hasErrorOfType('firstQuestionAnswer', 'required')) {
              <mat-error> Enter an answer for selected security
              question </mat-error>
            }
            @if (hasErrorOfType('firstQuestionAnswer', 'minlength') || hasErrorOfType('firstQuestionAnswer', 'maxlength')) {
              <mat-error
                >
                Enter a valid answer that is between 5 and 20 characters in length.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="fx-layout-row fx-layout-xs-column">
        <div class="fx-flex-35">
          <mat-form-field>
            <mat-label>Security Question 2</mat-label>
            <mat-select formControlName="secondQuestion">
              @for (question of getAvailableQuestions('secondQuestion'); track question) {
                <mat-option [value]="question.id">
                {{question.questionText}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="fx-flex-20 flex-offset-40px">
          <mat-form-field>
            <mat-label>Enter an answer</mat-label>
            <input matInput formControlName="secondQuestionAnswer">
            @if (hasErrorOfType('secondQuestionAnswer', 'required')) {
              <mat-error> Enter an answer for selected security
              question </mat-error>
            }
            @if (hasErrorOfType('secondQuestionAnswer', 'minlength') || hasErrorOfType('secondQuestionAnswer', 'maxlength')) {
              <mat-error
                >
                Enter a valid answer that is between 5 and 20 characters in length.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </form>
  }
  <div class="mt-3 fx-layout-row fx-layout-xs-column">
    <button [disabled]="isViewOnly" mat-raised-button color="primary" type="button" (click)="onSubmit()">Update Security Questions</button>
  </div>
</div>